import { ClientError } from './client-error';

export class DeprecatedConfigurationStartError extends ClientError {
  constructor(message?: string) {
    super(message);

    this.name = 'DeprecatedConfigurationStartError';
  }
}
